import { gql } from '@apollo/client';

// Admin-only community curation (/admin/community-curation). Types are
// hand-written in src/lib/community-curation/types.ts: production
// introspection is off, so there is no codegen for these operations.

const SETTINGS_FIELDS = `
  enabled
  global_daily_cap
  youtube_quota_budget
  curator { id name }
  added_today
  estimated_units_per_run
`;

const NICHE_FIELDS = `
  id
  name
  enabled
  region
  keywords
  seed_channels
  min_duration_minutes
  max_duration_minutes
  lookback_hours
  daily_limit
  created_at
  updated_at
`;

const RUN_FIELDS = `
  id
  trigger
  dry_run
  status
  started_at
  finished_at
  candidates_count
  added_count
  skipped_count
  failed_count
  youtube_units_used
  estimated_units
  budget_units
  niche_results { niche_id name searches candidates added note errors }
  error
`;

const PICK_FIELDS = `
  id
  video_id
  title
  channel_title
  published_at
  view_count
  velocity
  status
  reason
  error
  niche { id name }
  library { id curation_status }
  created_at
`;

export const ADMIN_COMMUNITY_CURATION_OVERVIEW = gql`
  query AdminCommunityCurationOverview {
    adminCommunityCurationSettings { ${SETTINGS_FIELDS} }
    adminCommunityCurationNiches { ${NICHE_FIELDS} }
  }
`;

export const ADMIN_COMMUNITY_CURATION_RUNS = gql`
  query AdminCommunityCurationRuns($limit: Int, $offset: Int) {
    adminCommunityCurationRuns(limit: $limit, offset: $offset) {
      data { ${RUN_FIELDS} }
      total
    }
  }
`;

export const ADMIN_COMMUNITY_CURATION_RUN = gql`
  query AdminCommunityCurationRun($id: ID!) {
    adminCommunityCurationRun(id: $id) { ${RUN_FIELDS} }
  }
`;

export const ADMIN_COMMUNITY_CURATION_PICKS = gql`
  query AdminCommunityCurationPicks($runId: ID, $status: String, $limit: Int, $offset: Int) {
    adminCommunityCurationPicks(runId: $runId, status: $status, limit: $limit, offset: $offset) {
      data { ${PICK_FIELDS} }
      total
    }
  }
`;

export const ADMIN_UPDATE_COMMUNITY_CURATION_SETTINGS = gql`
  mutation AdminUpdateCommunityCurationSettings($input: AdminCommunityCurationSettingsInput!) {
    adminUpdateCommunityCurationSettings(input: $input) { ${SETTINGS_FIELDS} }
  }
`;

export const ADMIN_CREATE_COMMUNITY_CURATION_NICHE = gql`
  mutation AdminCreateCommunityCurationNiche($input: AdminCommunityCurationNicheInput!) {
    adminCreateCommunityCurationNiche(input: $input) { ${NICHE_FIELDS} }
  }
`;

export const ADMIN_UPDATE_COMMUNITY_CURATION_NICHE = gql`
  mutation AdminUpdateCommunityCurationNiche($id: ID!, $input: AdminCommunityCurationNicheInput!) {
    adminUpdateCommunityCurationNiche(id: $id, input: $input) { ${NICHE_FIELDS} }
  }
`;

export const ADMIN_DELETE_COMMUNITY_CURATION_NICHE = gql`
  mutation AdminDeleteCommunityCurationNiche($id: ID!) {
    adminDeleteCommunityCurationNiche(id: $id)
  }
`;

export const ADMIN_RUN_COMMUNITY_CURATION = gql`
  mutation AdminRunCommunityCuration($dryRun: Boolean) {
    adminRunCommunityCuration(dryRun: $dryRun) { ${RUN_FIELDS} }
  }
`;

export const ADMIN_ADD_COMMUNITY_CURATION_VIDEO = gql`
  mutation AdminAddCommunityCurationVideo($url: String!, $nicheId: ID, $region: String) {
    adminAddCommunityCurationVideo(url: $url, nicheId: $nicheId, region: $region) { ${PICK_FIELDS} }
  }
`;
